// AWS userpool data
export const awsExports = {
  aws_project_region: process.env.REACT_APP_AWS_PROJECT_REGION,
  aws_user_pools_id: process.env.REACT_APP_AWS_EXPORTS_USER_POOLS_ID,
  aws_user_pools_web_client_id:
    process.env.REACT_APP_AWS_EXPORTS_USER_POOLS_WEB_CLIENT_ID,
};
